export default __webpack_public_path__ + "static/media/icon_collect_status_audit_pass.bec0187f.png";